import axios from 'axios';

const BASIC_API_URL = '/coreService';
const API_URIS = {
	product: process.env.REACT_APP_NODE_PRODUCT_API_URL,
	stock: process.env.REACT_APP_NODE_STOCK_API_URL,
	product_attribute: process.env.REACT_APP_NODE_PRODUCT_ATTRIBUTE_API_URL,
	product_attribute_value: process.env.REACT_APP_NODE_PRODUCT_ATTRIBUTE_VALUES_API_URL,
	product_variant: process.env.REACT_APP_NODE_PRODUCT_VARIANT_API_URL,
	stock_location: process.env.REACT_APP_NODE_STOCK_LOCATION_API_URL,
	stock_movement: process.env.REACT_APP_NODE_STOCK_MOVEMENT_API_URL,
	stock_warehouse: process.env.REACT_APP_NODE_STOCK_WAREHOUSE_API_URL,
	category: process.env.REACT_APP_NODE_CATEGORY_API_URL,
	brand: process.env.REACT_APP_NODE_BRAND_API_URL,
	attachment: process.env.REACT_APP_NODE_ATTACHMENT_API_URL,
	order: process.env.REACT_APP_NODE_ORDER_API_URL,
	order_line: process.env.REACT_APP_NODE_ORDER_LINE_API_URL,
	caisse: process.env.REACT_APP_NODE_CAISSE_API_URL,
	session: process.env.REACT_APP_NODE_SESSION_API_URL,
	customer: process.env.REACT_APP_NODE_CUSTOMER_API_URL,
	employee: process.env.REACT_APP_NODE_EMPLOYEE_API_URL1,
	contrat: process.env.REACT_APP_NODE_CONTRAT_API_URL,
	colis: process.env.REACT_APP_NODE_COLIS_API_URL,
	user: process.env.REACT_APP_NODE_USER_API_URL,
	pointage: process.env.REACT_APP_NODE_POINTAGE_API_URL,
	employeeJob: process.env.REACT_APP_API_EMPLOYEEJOB_API_URI,
	enlevement: process.env.REACT_APP_API_ENLEVEMENT_API_URI,
	EnlevementLine: process.env.REACT_APP_API_ENLEVEMENT_API_URI,
	tracking: process.env.REACT_APP_API_TRACKING_API_URI,
	planning: process.env.REACT_APP_NODE_PLANNING_API_URL,
	livraison: process.env.REACT_APP_NODE_LIVRAISON_API_URL,
	order_movement: process.env.REACT_APP_NODE_ORDER_MOVEMENT_API_URL,
	company: process.env.REACT_APP_NODE_COMPANY_API_URL,
	module: process.env.REACT_APP_NODE_MODULE_API_URL,
	promo: process.env.REACT_APP_NODE_STOCK_PROMO_API_URL,
	orderFabrication: process.env.REACT_APP_NODE_ORDER_FABRICATION_API_URL,
	nomenclature: process.env.REACT_APP_NODE_NOMENCLATURE_API_URL,
	achat: process.env.REACT_APP_NODE_ACHAT_API_URL,
	contrat: process.env.REACT_APP_NODE_CONTRAT_API_URL,
	delivery_credential: process.env.REACT_APP_NODE_DELIVERY_CREDENTIAL_API_URL,
	delivery_provider: process.env.REACT_APP_NODE_DELIVERY_PROVIDER_API_URL,
	voiture: process.env.REACT_APP_NODE_VOITURE_API_URL,
	contrat1: process.env.REACT_APP_NODE_CONTRAT_API_URL1,
	domain: process.env.REACT_APP_GET_ALL_OVH_DOMAINS_URL,
	server: process.env.REACT_APP_GET_SERVER_URL,
	telephony: process.env.REACT_APP_TELEPHONY_URL,
	workspace: process.env.REACT_APP_API_WORKSPACE_API_URI,
	group: process.env.REACT_APP_API_GROUP_API_URI,
	project: process.env.REACT_APP_API_PROJECT_API_URI,
	kanbanBoard: process.env.REACT_APP_API_KANBANBOARD_API_URI,
	column: process.env.REACT_APP_API_COLUMN_API_URI,
	ticket: process.env.REACT_APP_API_TICKET_API_URI,
	comment: process.env.REACT_APP_API_COMMENT_API_URI,
	statusChange: process.env.REACT_APP_API_STATUSCHANGE_API_URI,
	society: process.env.REACT_APP_SOCIETY_URL,
	store2000_client: process.env.REACT_APP_STORE_2000_CLIENT_URL,
	dm_client: process.env.REACT_APP_DM_CLIENT_URL,
	poste: process.env.REACT_APP_API_POSTE_API_URI,
	departement: process.env.REACT_APP_API_DEPARTEMENT_API_URI,
	role: process.env.REACT_APP_API_ROLE_API_URI,
};

const LIMIT = 0;

const handleAxios = (config) => {
	return new Promise((resolve, reject) => {
		// Ensure cookies are sent with every request
		const finalConfig = {
			...config,
			withCredentials: true, // <--- send HttpOnly cookies automatically
		};

		axios(finalConfig)
			.then((response) => resolve(response?.data))
			.catch((error) => {
				if (error?.code !== 'ERR_CANCELED') {
					reject(error);
				} else {
					resolve(null);
				}
			});
	});
};

export const getAPI = async (
	token,
	type,
	fnSuccess = () => {},
	fnError = () => {},
	signal = null,
) => {
	if (!API_URIS[type]) {
		throw new Error(`Invalid API type: ${type}`);
	}
	if (!API_URIS[type]) {
		throw new Error(`Invalid API type: ${type}`);
	}
	const url = BASIC_API_URL + API_URIS[type];

	const config = {
		method: 'get',
		url: url,
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		signal,
	};

	const res = await handleAxios(config);
	try {
		fnSuccess(res);
		return res;
	} catch (error) {
		fnError(error);
	}
};

export const getAPIById = async (
	token,
	type,
	id,
	fnSuccess = () => {},
	fnError = () => {},
	signal = null,
) => {
	if (!API_URIS[type]) {
		throw new Error(`Invalid API type: ${type}`);
	}
	const url = BASIC_API_URL + API_URIS[type] + '/' + id;

	const config = {
		method: 'get',
		url: url,
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		signal,
	};

	const res = await handleAxios(config);
	try {
		fnSuccess(res);
		return res;
	} catch (error) {
		fnError(error);
	}
};
export const updateCustomizedAPI1 = async (
	token,
	type,
	id,
	newData,
	addedUrl,
	fnSuccess = () => {},
	fnError = () => {},
) => {
	if (!API_URIS[type]) {
		throw new Error(`Invalid API type: ${type}`);
	}

	const data = JSON.stringify(newData);
	const url = BASIC_API_URL + API_URIS[type] + '/' + id;

	const config = {
		method: 'put',
		url: url,
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		data: data,
	};
	const res = await handleAxios(config);
	try {
		fnSuccess(res);
		return res;
	} catch (error) {
		fnError(error);
	}
};
export const searchAPI = async (
	token,
	type,
	filters,
	page = 0,
	limit = 0,
	fnSuccess = () => {},
	fnError = () => {},
	signal = null,
) => {
	if (!API_URIS[type]) {
		throw new Error(`Invalid API type: ${type}`);
	}
	const url = BASIC_API_URL + API_URIS[type] + '?page=' + page + '&limit=' + limit;

	const config = {
		method: 'patch',
		url: url,
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		data: JSON.stringify(filters),
		signal,
	};
	const res = await handleAxios(config);
	try {
		fnSuccess(res);
		return res;
	} catch (error) {
		fnError(error);
	}
};
export const searchAPITRI = async (
	token,
	type,
	filters,
	page = 0,
	limit = 0,
	sortField,
	sortOrder,
	fnSuccess = () => {},
	fnError = () => {},
	signal = null,
) => {
	if (!API_URIS[type]) {
		throw new Error(`Invalid API type: ${type}`);
	}

	const url = BASIC_API_URL + API_URIS[type] + '?page=' + page + '&limit=' + limit;

	const config = {
		method: 'patch',
		url: url,
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		data: JSON.stringify({
			filters,
			sortField,
			sortOrder,
		}),
		signal,
	};

	try {
		const res = await handleAxios(config);
		fnSuccess(res);
		return res;
	} catch (error) {
		fnError(error);
	}
};

export const searchcusromizeAPI = async (
	token,
	type,
	addedUrl,
	filters,
	page = 0,
	limit = 0,
	fnSuccess = () => {},
	fnError = () => {},
	signal = null,
) => {
	if (!API_URIS[type]) {
		throw new Error(`Invalid API type: ${type}`);
	}
	const url = BASIC_API_URL + API_URIS[type] + addedUrl + '?page=' + page + '&limit=' + limit;

	const config = {
		method: 'patch',
		url: url,
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		data: JSON.stringify(filters),
		signal,
	};
	const res = await handleAxios(config);
	try {
		fnSuccess(res);
		return res;
	} catch (error) {
		fnError(error);
	}
};
export const searchcusromizeAPIPointage = async (
	token,
	type,
	addedUrl,
	options = {}, // contient `params`, `signal`, etc.
	filters,
	page = 0,
	limit = 0,
	fnSuccess = () => {},
	fnError = () => {},
	signal = null,
) => {
	if (!API_URIS[type]) {
		throw new Error(`Invalid API type: ${type}`);
	}
	const url = BASIC_API_URL + API_URIS[type] + addedUrl + '?page=' + page + '&limit=' + limit;

	const config = {
		method: 'patch',
		url: url,
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		...options,
		data: JSON.stringify(filters),
		signal,
	};
	const res = await handleAxios(config);
	try {
		fnSuccess(res);
		return res;
	} catch (error) {
		fnError(error);
	}
};
export const patchcusromizeAPIPointage = async (
	token,
	type,
	addedUrl,
	options = {}, // params, signal, data (body), etc.
	page = 0,
	limit = 0,
	fnSuccess = () => {},
	fnError = () => {},
) => {
	if (!API_URIS[type]) {
		throw new Error(`Invalid API type: ${type}`);
	}

	const url = BASIC_API_URL + API_URIS[type] + addedUrl + `?page=${page}&limit=${limit}`;

	const config = {
		method: 'patch',
		url,
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		...options,
		data: JSON.stringify(options.data || {}), // 👈 body
	};

	try {
		const res = await handleAxios(config);
		fnSuccess(res);
		return res;
	} catch (error) {
		fnError(error);
		throw error;
	}
};

export const createAPI = async (
	token,
	type,
	newData,
	fnSuccess = () => {},
	fnError = () => {},
	signal = null,
) => {
	if (!API_URIS[type]) {
		throw new Error(`Invalid API type: ${type}`);
	}

	const data = JSON.stringify(newData);
	const url = BASIC_API_URL + API_URIS[type];
	let config = {
		method: 'post',
		url: url,
		headers: {
			Authorization: `Bearer ${token}`,
		},
		maxContentLength: Infinity,
		maxBodyLength: Infinity,
		signal,
	};

	if (type === 'attachment') {
		// Create FormData for image upload
		const formData = new FormData();
		Object.keys(newData).forEach((key) => {
			if (key === 'datass') {
				// Convert base64 string back to binary and append it to FormData
				const binaryData = atob(newData[key]);
				const arrayBuffer = new Uint8Array(binaryData.length);
				for (let i = 0; i < binaryData.length; i++) {
					arrayBuffer[i] = binaryData.charCodeAt(i);
				}
				const blob = new Blob([arrayBuffer], { type: newData.mimetype });
				formData.append('datas', blob, newData.name);
			} else {
				formData.append(key, newData[key]);
			}
		});
		config.data = formData;
	} else {
		// Send data as JSON
		config.headers['Content-Type'] = 'application/json';
		config.data = JSON.stringify(newData);
	}

	const res = await handleAxios(config);
	// createTracking(token, {
	// 	action: 'create',
	// 	entityType: type,
	// 	entityId: res?._id || res?.id || res?.data?._id || res?.data?.id,
	// });
	try {
		fnSuccess(res);
		return res;
	} catch (error) {
		fnError(error);
	}
};

export const updateAPI = async (
	token,
	type,
	id,
	newData,
	fnSuccess = () => {},
	fnError = () => {},
	oldData = null,
) => {
	if (!API_URIS[type]) {
		throw new Error(`Invalid API type: ${type}`);
	}

	const data = JSON.stringify(newData);
	const url = BASIC_API_URL + API_URIS[type] + '/' + id;

	const config = {
		method: 'put',
		url: url,
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		data: data,
	};
	const res = await handleAxios(config);
	createTracking(token, {
		action: 'update',
		entityType: type,
		entityId: id,
		before: oldData,
		after: newData,
	});
	try {
		fnSuccess(res);
		return res;
	} catch (error) {
		fnError(error);
	}
};

export const updateAPI2 = async (
	token,
	type,
	id,
	newData,
	fnSuccess = () => {},
	fnError = () => {},
	oldData = null,
) => {
	if (!API_URIS[type]) {
		throw new Error(`Invalid API type: ${type}`);
	}

	const data = JSON.stringify(newData);
	const url = BASIC_API_URL + API_URIS[type] + id;

	const config = {
		method: 'put',
		url: url,
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		data: data,
	};
	const res = await handleAxios(config);
	createTracking(token, {
		action: 'update',
		entityType: type,
		entityId: id,
		before: oldData,
		after: newData,
	});
	try {
		fnSuccess(res);
		return res;
	} catch (error) {
		fnError(error);
	}
};
export const updatecosAPI = async (
	token,
	type,
	addedUrl,
	id,
	newData,
	fnSuccess = () => {},
	fnError = () => {},
	oldData = null,
) => {
	if (!API_URIS[type]) {
		throw new Error(`Invalid API type: ${type}`);
	}

	const data = JSON.stringify(newData);
	const url = BASIC_API_URL + API_URIS[type] + addedUrl + '/' + id;

	const config = {
		method: 'put',
		url: url,
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		data: data,
	};
	const res = await handleAxios(config);
	createTracking(token, {
		action: 'update',
		entityType: type,
		entityId: id,
		before: oldData,
		after: newData,
	});
	try {
		fnSuccess(res);
		return res;
	} catch (error) {
		fnError(error);
	}
};
export const updateCustomizedAPI = async (
	token,
	type,
	id,
	newData,
	addedUrl,
	fnSuccess = () => {},
	fnError = () => {},
) => {
	if (!API_URIS[type]) {
		throw new Error(`Invalid API type: ${type}`);
	}

	const data = JSON.stringify(newData);
	const url = BASIC_API_URL + API_URIS[type] + addedUrl + '/' + id;

	const config = {
		method: 'put',
		url: url,
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		data: data,
	};
	const res = await handleAxios(config);
	try {
		fnSuccess(res);
		return res;
	} catch (error) {
		fnError(error);
	}
};

export const getCustomizedAPI = async (
	token,
	type,
	addedUrl,
	fnSuccess = () => {},
	fnError = () => {},
	signal = null,
) => {
	if (!API_URIS[type]) {
		throw new Error(`Invalid API type: ${type}`);
	}
	const url = BASIC_API_URL + API_URIS[type] + addedUrl;

	const config = {
		method: 'get',
		url: url,
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		signal,
	};

	const res = await handleAxios(config);
	try {
		fnSuccess(res);
		return res;
	} catch (error) {
		fnError(error);
	}
};
export const getCustomizedAPI11 = async (
	token,
	type,
	addedUrl,
	fnSuccess = () => {},
	fnError = () => {},
	signal = null,
) => {
	if (!API_URIS[type]) throw new Error(`Invalid API type: ${type}`);
	const url = BASIC_API_URL + API_URIS[type] + addedUrl;

	const config = {
		method: 'get',
		url,
		headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
		signal,
	};

	try {
		const data = await handleAxios(config); // <-- body déjà déballé
		fnSuccess(data);
		return data; // <-- renvoyer le body directement
	} catch (err) {
		fnError(err);
		throw err;
	}
};

export const getCustomizedAPIPointage = async (
	token,
	type,
	addedUrl,
	options = {}, // contient `params`, `signal`, etc.
	fnSuccess = () => {},
	fnError = () => {},
) => {
	if (!API_URIS[type]) {
		throw new Error(`Invalid API type: ${type}`);
	}

	const url = BASIC_API_URL + API_URIS[type] + addedUrl;

	const config = {
		method: 'get',
		url: url,
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		...options, // <-- ici on passe `params` correctement
	};

	try {
		const res = await handleAxios(config);
		fnSuccess(res);
		return res;
	} catch (error) {
		fnError(error);
		throw error;
	}
};

export const getCustomizedAPI3 = async (
	token,
	type,
	addedUrl,
	id,
	fnSuccess = () => {},
	fnError = () => {},
	signal = null,
) => {
	if (!API_URIS[type]) {
		throw new Error(`Invalid API type: ${type}`);
	}
	const url = BASIC_API_URL + API_URIS[type] + addedUrl + '/' + id;

	const config = {
		method: 'get',
		url: url,
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		signal,
	};

	const res = await handleAxios(config);
	try {
		fnSuccess(res);
		return res;
	} catch (error) {
		fnError(error);
	}
};
export const searchCustomizedAPI = async (
	token,
	type,
	addedUrl,
	filters,
	page = 0,
	limit = 0,
	fnSuccess = () => {},
	fnError = () => {},
	signal = null,
) => {
	if (!API_URIS[type]) {
		throw new Error(`Invalid API type: ${type}`);
	}
	const url = BASIC_API_URL + API_URIS[type] + addedUrl + '?page=' + page + '&limit=' + limit;

	const config = {
		method: 'patch',
		url: url,
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		data: JSON.stringify(filters),
		signal,
	};
	const res = await handleAxios(config);
	try {
		fnSuccess(res);
		return res;
	} catch (error) {
		fnError(error);
	}
};

export const searchCustomizedAPI11 = async (
	token,
	type,
	addedUrl,
	filters,
	page = 0,
	limit = 0,
	fnSuccess = () => {},
	fnError = () => {},
	signal = null,
) => {
	if (!API_URIS[type]) {
		throw new Error(`Invalid API type: ${type}`);
	}

	const url = `${BASIC_API_URL}${API_URIS[type]}${addedUrl}?page=${page}&limit=${limit}`;

	const config = {
		method: 'patch',
		url: url,
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		data: filters, // ✅ Correction ici : on passe un objet, pas un JSON stringifié
		signal,
	};

	try {
		const res = await handleAxios(config);
		fnSuccess(res);
		return res;
	} catch (error) {
		fnError(error);
		throw error;
	}
};

export const searchCustomizedAPI2 = async (
	token,
	type,
	addedUrl,
	filters,
	page = 0,
	limit = 0,
	fnSuccess = () => {},
	fnError = () => {},
	signal = null,
) => {
	if (!API_URIS[type]) {
		throw new Error(`Invalid API type: ${type}`);
	}
	const url = BASIC_API_URL + API_URIS[type] + addedUrl + '&page=' + page + '&limit=' + limit;

	const config = {
		method: 'patch',
		url: url,
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		data: JSON.stringify(filters),
		signal,
	};
	const res = await handleAxios(config);
	try {
		fnSuccess(res);
		return res;
	} catch (error) {
		fnError(error);
	}
};

export const searchCustomizedAPI15 = async (
	token,
	type,
	addedUrl,
	filters,
	page = 0,
	limit = 0,
	fnSuccess = () => {},
	fnError = () => {},
	signal = null,
) => {
	if (!API_URIS[type]) {
		throw new Error(`Invalid API type: ${type}`);
	}
	const url = BASIC_API_URL + API_URIS[type] + addedUrl + '?page=' + page + '&limit=' + limit;

	const config = {
		method: 'get',
		url: url,
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		params: filters,
		signal,
	};
	const res = await handleAxios(config);
	try {
		fnSuccess(res);
		return res;
	} catch (error) {
		fnError(error);
	}
};

export const searchCustomizedAPIWithDates = async (
	token,
	type,
	addedUrl,
	filters,
	startDate,
	endDate,
	page = 0,
	limit = 0,
	fnSuccess = () => {},
	fnError = () => {},
	signal = null,
) => {
	if (!API_URIS[type]) {
		throw new Error(`Invalid API type: ${type}`);
	}
	const url =
		BASIC_API_URL +
		API_URIS[type] +
		addedUrl +
		'?page=' +
		page +
		'&limit=' +
		limit +
		'&startDate=' +
		startDate +
		'&endDate=' +
		endDate;

	const config = {
		method: 'patch',
		url: url,
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		data: JSON.stringify(filters),
		signal,
	};
	const res = await handleAxios(config);
	try {
		fnSuccess(res);
		return res;
	} catch (error) {
		fnError(error);
	}
};

export const searchAPINew = async (token, type, filters, signal = null) => {
	if (!API_URIS[type]) {
		throw new Error(`Invalid API type: ${type}`);
	}
	const url = BASIC_API_URL + API_URIS[type];

	const config = {
		method: 'patch',
		url: url,
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		data: JSON.stringify(filters),
		signal,
	};
	const res = await handleAxios(config);
	try {
		return res;
	} catch (error) {}
};

export const deleteAPI = async (
	token,
	type,
	id,
	newData,
	fnSuccess = () => {},
	fnError = () => {},
) => {
	if (!API_URIS[type]) {
		throw new Error(`Invalid API type: ${type}`);
	}

	const data = JSON.stringify(newData);
	const url = BASIC_API_URL + API_URIS[type] + '/' + id;

	const config = {
		method: 'delete',
		url: url,
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
	};

	const res = await handleAxios(config);
	createTracking(token, {
		action: 'delete',
		entityType: type,
		entityId: id,
	});
	try {
		fnSuccess(res);
		return res;
	} catch (error) {
		fnError(error);
	}
};

export const deleteCustomaizedAPI = async (
	token,
	type,
	addedUrl,
	id,
	newData,
	fnSuccess = () => {},
	fnError = () => {},
) => {
	if (!API_URIS[type]) {
		throw new Error(`Invalid API type: ${type}`);
	}

	const data = JSON.stringify(newData);
	const url = BASIC_API_URL + API_URIS[type] + addedUrl + '/' + id;

	const config = {
		method: 'delete',
		url: url,
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
	};

	const res = await handleAxios(config);
	createTracking(token, {
		action: 'delete',
		entityType: type,
		entityId: id,
	});
	try {
		fnSuccess(res);
		return res;
	} catch (error) {
		fnError(error);
	}
};

export const postCustomizedAPI = async (
	token,
	type,
	addedUrl,
	newData,
	fnSuccess = () => {},
	fnError = () => {},
	signal = null,
) => {
	if (!API_URIS[type]) {
		throw new Error(`Invalid API type: ${type}`);
	}
	const data = JSON.stringify(newData);
	const url = BASIC_API_URL + API_URIS[type] + addedUrl;

	const config = {
		method: 'post',
		url: url,
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		maxContentLength: Infinity,
		maxBodyLength: Infinity,
		data: data,
		signal,
	};

	const res = await handleAxios(config);
	try {
		fnSuccess(res);
		return res;
	} catch (error) {
		fnError(error);
	}
};

export const functionWrapperWithPromise = (fn, ...args) => {
	return new Promise((resolve, reject) => {
		fn(...args, resolve, reject);
	});
};

export const createTracking = async (token, newData = {}) => {
	// Ensure that a valid tracking endpoint exists
	if (!API_URIS['tracking']) {
		throw new Error(`Invalid API type: "tracking"`);
	}

	// Define the tracking API URL
	const url = BASIC_API_URL + API_URIS['tracking'];

	// Configure the request options
	const config = {
		method: 'post',
		url: url,
		headers: {
			Authorization: `Bearer ${token}`,
			'Content-Type': 'application/json',
		},
		data: JSON.stringify(newData),
	};
};

export const getCustomizedAPI2 = async (
	token,
	type,
	addedUrl,
	id,
	fnSuccess = () => {},
	fnError = () => {},
	signal = null,
) => {
	if (!API_URIS[type]) {
		throw new Error(`Invalid API type: ${type}`);
	}
	const url = BASIC_API_URL + API_URIS[type] + addedUrl + '/' + id;

	const config = {
		method: 'get',
		url: url,
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		signal,
	};

	const res = await handleAxios(config);
	try {
		fnSuccess(res);
		return res;
	} catch (error) {
		fnError(error);
	}
};

export const getCustomizedAPIBYID1 = async (
	token,
	type,
	addedUrl,
	id,
	fnSuccess = () => {},
	fnError = () => {},
	signal = null,
) => {
	if (!API_URIS[type]) {
		throw new Error(`Invalid API type: ${type}`);
	}
	const url = BASIC_API_URL + API_URIS[type] + addedUrl + '/' + id;

	const config = {
		method: 'get',
		url: url,
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		signal,
	};

	const res = await handleAxios(config);
	try {
		fnSuccess(res);
		return res;
	} catch (error) {
		fnError(error);
	}
};
